import Vue from 'vue'
import Router from 'vue-router'
import home from '@/view/home'
import record from '@/view/record'
import login from '@/view/login'
import prop from '@/view/myProp'
import ranking from '@/view/ranking'

Vue.use(Router)

export default new Router({
  mode: 'hash',
  routes: [
    {
      path: '/',
      name: 'home',
      component: home
    },
    {
      path: '/record',
      name: 'record',
      component: record
    },
    {
      path: '/login',
      name: 'login',
      component: login
    },
    {
      path: '/prop',
      name: 'prop',
      component: prop
    },
    {
      path: '/ranking',
      name: 'ranking',
      component: ranking
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js